import React from "react";
import { Reveal } from "./Reveal";
import { BENEFITS } from "../../data/content";

const Overview = () => {
  return (
    <section id="overview" data-testid="overview-section" className="py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-5">
              / What is ROLL.OPS
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
              A command center for selling and rolling covered calls.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-zinc-400 leading-relaxed">
              ROLL.OPS is built for income traders running the wheel and covered
              call strategies. It's an educational workspace: you manually enter
              your positions, model different rolls, and learn the mechanics —
              without ever connecting to your bank or brokerage.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="rolling-definition"
            className="mt-12 border-l-2 border-cyan-400 bg-[#0A0A0A] px-7 py-6 max-w-3xl"
          >
            <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-3">
              / What "rolling a covered call" means
            </p>
            <p className="text-lg text-zinc-300 leading-relaxed">
              Rolling means you <span className="text-white font-medium">buy back the call
              you previously sold</span> and, at the same moment,{" "}
              <span className="text-white font-medium">sell a new call</span> against the
              same shares — usually at a different strike or a later expiration. For now,
              ROLL.OPS focuses <span className="text-white font-medium">only on covered
              calls</span> — nothing else.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div
            data-testid="real-data-note"
            className="mt-5 border-l-2 border-green-400 bg-[#0A0A0A] px-7 py-6 max-w-3xl"
          >
            <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-green-400 mb-3">
              / Real data — not simulations
            </p>
            <p className="text-lg text-zinc-300 leading-relaxed">
              Even though ROLL.OPS never connects to your account,{" "}
              <span className="text-white font-medium">nothing here is fake</span>.
              Every analysis is built from your{" "}
              <span className="text-white font-medium">actual position inputs</span>{" "}
              and <span className="text-white font-medium">live option prices from
              Tradier</span> — real, live market data. Nothing here is simulated.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-5">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.tag} delay={i * 0.08} className={b.span}>
              <div
                data-testid={`benefit-card-${i + 1}`}
                className="h-full bg-[#0A0A0A] border border-white/10 p-8 hover:border-white/25 transition-colors duration-300 group relative overflow-hidden"
              >
                <div className="absolute top-0 left-0 h-px w-0 bg-cyan-400 group-hover:w-full transition-all duration-500" />
                <p className="font-mono text-xs uppercase tracking-[0.18em] text-zinc-500">
                  {b.tag}
                </p>
                <h3 className="mt-5 font-display text-xl sm:text-2xl font-medium tracking-tight text-white">
                  {b.title}
                </h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Overview;
